import React from 'react';
const testimonials = [{
  name: 'Claire D.',
  location: 'Lyon 🇫🇷',
  quote: "Ce pack m'a sauvé. Avec 20 heures de cours par semaine, je peux enfin me concentrer sur mes élèves, le travail administratif est déjà fait.",
  initials: 'CD'
}, {
  name: 'Marc L.',
  location: 'Paris 🇫🇷',
  quote: 'Les séances pour le BAC sont structurées de manière très professionnelle. Un excellent investissement pour ma carrière.',
  initials: 'ML'
}, {
  name: 'Sophie G.',
  location: 'Bordeaux 🇫🇷',
  quote: "Je l'utilise surtout pour les Bonus Plan B quand il pleut. Les fiches théoriques pour la classe sont parfaitement conçues.",
  initials: 'SG'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <div className="text-center mb-12 sm:mb-16" data-id="element-176">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-177">
            Ce que disent vos collègues professeurs d'EPS...
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-178">
            <span className="text-secondary text-lg" data-id="element-179">⭐⭐⭐⭐⭐</span>
            <span className="text-text-sec font-medium" data-id="element-180">
              4.9/5 · +3 000 Enseignants
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-main rounded-2xl p-6 border border-border-light shadow-sm flex flex-col" data-id="element-182">
              <div className="flex items-center gap-2 mb-4" data-id="element-183">
                <span className="text-secondary text-sm" data-id="element-184">⭐⭐⭐⭐⭐</span>
              </div>
              <p className="text-text-main text-base leading-relaxed mb-6 flex-grow italic" data-id="element-185">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-186">
                <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-187">
                  {t.initials}
                </div>
                <div data-id="element-188">
                  <p className="text-text-main font-bold text-sm" data-id="element-189">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-190">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}